"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("src/utilities/styled/color"));
exports.default = (function (_a) {
    var disabled = _a.disabled, color = _a.color;
    return function (_a) {
        var theme = _a.theme;
        if (disabled) {
            return theme.palette.dropdownColor[1];
        }
        if (color) {
            return (0, color_1.default)({ theme: theme, color: color });
        }
        return theme.palette.dropdownColor[0];
    };
});
